var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowTop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.763838 5.73633C0.594903 5.56755 0.5 5.33867 0.5 5.10003C0.5 4.86138 0.594903 4.6325 0.763838 4.46373L4.36834 0.863725C4.53733 0.695001 4.76649 0.600217 5.00544 0.600217C5.24439 0.600217 5.47355 0.695001 5.64254 0.863725L9.24704 4.46372C9.41119 4.63347 9.50202 4.86081 9.49997 5.09679C9.49791 5.33276 9.40314 5.55849 9.23607 5.72536C9.06899 5.89223 8.84298 5.98688 8.6067 5.98893C8.37043 5.99098 8.1428 5.90027 7.97285 5.73632L5.90657 3.67262L5.90657 10.5C5.90657 10.7387 5.81163 10.9676 5.64263 11.1364C5.47364 11.3052 5.24443 11.4 5.00544 11.4C4.76645 11.4 4.53724 11.3052 4.36825 11.1364C4.19925 10.9676 4.10431 10.7387 4.10431 10.5L4.10431 3.67262L2.03803 5.73632C1.86904 5.90505 1.63988 5.99983 1.40093 5.99983C1.16199 5.99983 0.932825 5.90505 0.763838 5.73633Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTop);
export default __webpack_public_path__ + "static/media/arrow-top.943376084002512876f42a699dfef3b7.svg";
export { ForwardRef as ReactComponent };